"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _FileDownload = _interopRequireDefault(require("@rsuite/icon-font/lib/action/FileDownload"));

// Generated by script, don't edit it please.
var FileDownload = (0, _createSvgIcon["default"])({
  as: _FileDownload["default"],
  ariaLabel: 'file download',
  category: 'action',
  displayName: 'FileDownload'
});
var _default = FileDownload;
exports["default"] = _default;
module.exports = exports.default;